const ThirdPartyVoucherCode = {
  ManualInput: "manual-input",
  UploadCsv: "upload-csv",
};

export default ThirdPartyVoucherCode;
